import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useSurfaceColorAtElevation } from '..';
import Tooltip from '../Tooltip';
import { useTheme } from '@emotion/react';
const StatusIndicator = (props) => {
    const theme = useTheme();
    const surfaceColor = useSurfaceColorAtElevation(x => x + 1);
    return (_jsx(Tooltip, { content: props.tooltip, children: _jsx("div", { className: props.className, css: {
                display: 'inline-block',
                width: '0.8rem',
                minWidth: '0.8rem',
                height: '0.8rem',
                borderRadius: theme.shape.extraSmall,
                transition: '0.5s',
                backgroundColor: (() => {
                    switch (props.status) {
                        case 'success':
                            return '#38D448';
                        case 'warning':
                            return '#F48F45';
                        case 'error':
                            return '#D22424';
                        case undefined:
                            return surfaceColor;
                    }
                })(),
            } }) }));
};
export default StatusIndicator;
//# sourceMappingURL=StatusIndicator.js.map